/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_v2_analytics_base_FilterItem } from './api_v2_analytics_base_FilterItem';
export type api_v2_analytics_unsaved_reports_UpdateUnsavedReport = {
    columns: Array<string>;
    filters?: Array<api_v2_analytics_base_FilterItem>;
    grouping: api_v2_analytics_unsaved_reports_UpdateUnsavedReport.grouping;
    name?: string;
    recalculation_needed?: boolean;
    source: string;
};
export namespace api_v2_analytics_unsaved_reports_UpdateUnsavedReport {
    export enum grouping {
        USER = 'user',
        ACCOUNT = 'account',
        BANK = 'bank',
        INSTRUMENT = 'instrument',
    }
}

